import { useTranslation } from "react-i18next";
import React from "react";
import { NavLink } from "react-router-dom";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import ListAltIcon from "@mui/icons-material/ListAlt";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useAuth } from "./AuthContext";

function Sidebar() {
  const { userRole, currentUser, organizationName } = useAuth();
  const { t } = useTranslation();

  const navItems = {
    admin: [
      {
        text: t("nav.dashboard"),
        to: "/app/dashboard",
        icon: <DashboardIcon />,
      },
      {
        text: t("nav.userManagement"),
        to: "/app/user-management",
        icon: <PeopleIcon />,
      },
      {
        text: t("nav.customLists"),
        to: "/app/custom-lists",
        icon: <ListAltIcon />,
      },
      {
        text: t("nav.findTest"),
        to: "/app/find-test",
        icon: <FindInPageIcon />,
      },
      { text: t("nav.reports"), to: "/app/reports", icon: <AssessmentIcon /> },
      {
        text: t("nav.profile"),
        to: "/app/profile",
        icon: <AccountCircleIcon />,
      },
      { text: t("nav.support"), to: "/app/support", icon: <HelpOutlineIcon /> },
    ],
    pro_user: [
      {
        text: t("nav.dashboard"),
        to: "/app/dashboard",
        icon: <DashboardIcon />,
      },
      {
        text: t("nav.customLists"),
        to: "/app/custom-lists",
        icon: <ListAltIcon />,
      },
      {
        text: t("nav.findTest"),
        to: "/app/find-test",
        icon: <FindInPageIcon />,
      },
      { text: t("nav.reports"), to: "/app/reports", icon: <AssessmentIcon /> },
      {
        text: t("nav.profile"),
        to: "/app/profile",
        icon: <AccountCircleIcon />,
      },
      { text: t("nav.support"), to: "/app/support", icon: <HelpOutlineIcon /> },
    ],
    superuser: [],
    user: [
      {
        text: t("nav.dashboard"),
        to: "/app/dashboard",
        icon: <DashboardIcon />,
      },
      {
        text: t("nav.myTestHistory"),
        to: "/app/find-test",
        icon: <FindInPageIcon />,
      },
      { text: t("nav.reports"), to: "/app/reports", icon: <AssessmentIcon /> },
      {
        text: t("nav.profile"),
        to: "/app/profile",
        icon: <AccountCircleIcon />,
      },
      { text: t("nav.support"), to: "/app/support", icon: <HelpOutlineIcon /> },
    ],
  };

  let links = [];
  if (userRole === "admin" || userRole === "superuser") {
    links = [
      ...navItems.admin,
      ...(userRole === "superuser" ? navItems.superuser : []),
    ];
  } else if (userRole === "pro_user") {
    links = navItems.pro_user;
  } else if (userRole === "user") {
    links = navItems.user;
  }

  return (
    <Box
      sx={{
        width: 240,
        flexShrink: 0,
        backgroundColor: "#f4f6f8",
        borderRight: "1px solid #e0e0e0",
        position: "fixed",
        top: "64px",
        left: 0,
        bottom: 0,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ overflowY: "auto" }}>
        <List sx={{ paddingTop: 0, paddingBottom: 0 }}>
          {links.map((item) => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton
                component={NavLink}
                to={item.to}
                sx={{
                  paddingLeft: "24px",
                  paddingRight: "24px",
                  color: "#555",
                  "& .MuiListItemIcon-root": { color: "#555", minWidth: 40 },
                  "&.active": {
                    backgroundColor: "#e3f2fd",
                    color: "#0d47a1",
                    fontWeight: "bold",
                    "& .MuiListItemIcon-root": { color: "#0d47a1" },
                  },
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
      <Box sx={{ mt: 2 }}>
        {" "}
        {/* This pushes the following items to the bottom */}
        <Divider />
        <List>
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to="/app/beta"
              sx={{
                backgroundColor: "warning.light",
                color: "black",
                "&.active": {
                  backgroundColor: "warning.light",
                  fontWeight: "bold",
                },
              }}
            >
              <ListItemIcon sx={{ color: "black" }}>
                <StarIcon />
              </ListItemIcon>
              <ListItemText primary={t("nav.betaHub")} />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
      <Box sx={{ p: 2 }}>
        <Divider />
        <Box sx={{ pt: 2 }}>
          <Typography variant="subtitle1" sx={{ lineHeight: 1.2 }}>
            {currentUser?.displayName} ({userRole?.replace("_", " ")})
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {organizationName}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
export default Sidebar;
